// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"Gf5a669"};